module.exports = __webpack_public_path__ + "static/media/Undo.38e3ac79.svg";